import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GridTable from '@nadavshaar/react-grid-table';
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { FaFileCsv } from 'react-icons/fa';
import ValidView from '../../../components/app/validView';
import ConfigAxios from '../../../services/ConfigAxios';
import setColumns from './setColumns';

const InbursaProspects = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const { allowView, allowWrite, userToken } = ValidView('InbursaUsers');

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const [columnsGrid, setColumnsGrid] = useState([]);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [resetGridTable, setResetGridTable] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns());
      setRowsLoading(true);
    }
  }, [allowView]);

  const handleFileChange = (event) => {
    const selected = event.target.files && event.target.files[0];
    if (!selected) return;

    const isCsv = selected.type.includes('csv') || selected.name.toLowerCase().endsWith('.csv');
    if (isCsv) {
      setFile(selected);
      setUploadResult(null);
    } else {
      setFile(null);
      setUploadResult('invalid');
    }
  };

  const handleImport = () => {
    if (!file) return;
    setUploading(true);
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file, file.name);

    const { NERTHUS, options } = ConfigAxios();
    const uploadOptions = { headers: { 'Authorization': options.headers.Authorization } };
    const importUrl = NERTHUS + '/inbursa/inbursaUsers/whatsAppTemplateStatus/csv';

    console.log('[InbursaProspects] POST', importUrl);

    axios.post(importUrl, formData, uploadOptions)
      .then((response) => {
        console.log('[InbursaProspects] import response', response.data);
        setUploadResult('success');
        setFile(null);
        setPage(1);
        setResetGridTable(current => !current);
      })
      .catch((error) => {
        console.log('[InbursaProspects] import error', error);
        setUploadResult('danger');
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);

    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const urlBaseFetch = process.env.REACT_APP_NERTHUS_API_URL + `/inbursa/inbursaUsers/whatsAppTemplateStatus/csv?page=${page}&perPage=${pageSize}`;

    console.log('[InbursaProspects] GET', urlBaseFetch);

    const response = await fetch(urlBaseFetch, requestOptions)
      .then((response) => {
        setLoading(false);
        return response.json();
      }).catch((error) => {
        console.log('[InbursaProspects] fetch error', error);
        setLoading(false);
        return null;
      });

    console.log('[InbursaProspects] list response', response);

    if (!response?.data) return { rows: [], totalRows: 0 };

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  };

  if (!allowView) return null;

  return (
    <>
      <div className='titleView' style={{ marginTop: '20px' }}>
        <h4 style={{ textAlign: 'center' }}>Seguimiento de prospectos inbursa</h4>
      </div>

      <Row className="mb-3" style={{ margin: '20px' }}>
        <Form.Group as={Col} md="4">
          <Form.Label>Archivo CSV</Form.Label>
          <Form.Control
            type="file"
            accept=".csv"
            disabled={!allowWrite || uploading}
            onChange={handleFileChange}
          />
        </Form.Group>
        <Col md="2" style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Button
            type="button"
            variant="warning"
            disabled={!allowWrite || !file || uploading}
            onClick={handleImport}
          >
            <FaFileCsv /> {uploading ? ' Importando...' : ' Importar CSV'}
          </Button>
        </Col>
        {uploading && (
          <Col md="1" style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        )}
      </Row>

      {uploadResult === 'success' && (
        <Alert variant='success' style={{ margin: '0 20px' }}>Archivo importado correctamente.</Alert>
      )}
      {uploadResult === 'danger' && (
        <Alert variant='danger' style={{ margin: '0 20px' }}>Ocurrió un error al importar el archivo.</Alert>
      )}
      {uploadResult === 'invalid' && (
        <Alert variant='warning' style={{ margin: '0 20px' }}>Selecciona un archivo con extensión .csv</Alert>
      )}

      <div className="tableWrapper">
        {!rowsLoading
          ? (<Spinner animation="border" role="status" variant="secondary" >
            <span className="visually-hidden">Loading...</span>
          </Spinner>) : (
            <GridTable
              key={resetGridTable}
              columns={columnsGrid}
              rowIdField={'code'}
              onRowsRequest={onRowsRequest}
              isLoading={isLoading}
              pageSizes={rowsPerPageArray}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
              onPageChange={OnPageChange}
              showSearch={false}
              showColumnVisibilityManager={false}
            />
          )}
      </div>
    </>
  );
};

export default InbursaProspects;
